import { motion } from 'framer-motion';

const testimonials = [
  {
    initials: 'M.R.',
    color: 'bg-amber-100 text-amber-700',
    text: 'Tenía que hacer la posesión efectiva de mi mamá y no sabía por dónde empezar. Me guiaron en todo el proceso y se encargaron de los trámites sin que tuviera que preocuparme.',
    context: 'Herencia con bien raíz',
  },
  {
    initials: 'C.V.',
    color: 'bg-gray-100 text-gray-700',
    text: 'El caso tenía varios bienes y pensábamos que iba a ser más complicado. Fue todo bastante ordenado y claro desde el inicio.',
    context: 'Herencia múltiples bienes',
  },
  {
    initials: 'P.S.',
    color: 'bg-stone-100 text-stone-700',
    text: 'Necesitábamos avanzar rápido con la herencia para poder vender una propiedad. Nos ayudaron a resolver todo sin errores ni vueltas innecesarias.',
    context: 'Venta de propiedad heredada',
  },
  {
    initials: 'L.F.',
    color: 'bg-amber-100 text-amber-700',
    text: 'No teníamos experiencia con este tipo de trámites. Nos explicaron cada paso y se encargaron de la gestión completa.',
    context: 'Primera gestión de herencia',
  },
  {
    initials: 'R.A.',
    color: 'bg-gray-100 text-gray-700',
    text: 'Habíamos intentado avanzar por nuestra cuenta y tuvimos problemas. Después de tomar el servicio, el proceso fue mucho más claro y fluido.',
    context: 'Proceso retomado',
  },
  {
    initials: 'K.M.',
    color: 'bg-stone-100 text-stone-700',
    text: 'Lo que más destaco es la rapidez y la claridad. Es un trámite que puede ser complejo, pero lo simplificaron bastante.',
    context: 'Trámite rápido y sin fricciones',
  },
];

const PosesionTestimonials = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-14"
        >
          <p className="text-xs font-bold tracking-widest text-gray-400 uppercase mb-4">
            Experiencias reales
          </p>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
            <h2 className="text-4xl lg:text-5xl font-bold text-black leading-tight max-w-xl">
              Lo que dicen quienes ya
              <br />
              <span className="text-black">resolvieron su herencia</span>
            </h2>
            <p className="text-sm text-gray-500 max-w-xs lg:text-right leading-relaxed">
              Casos reales de familias que completaron su posesión efectiva con acompañamiento profesional.
            </p>
          </div>
          <div className="mt-10 w-full h-px bg-gray-100"></div>
        </motion.div>

        {/* Grid 3 cols */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.55 }}
              className="border border-gray-100 rounded-2xl p-8 hover:border-primary-yellow transition-all duration-300 bg-white flex flex-col justify-between group cursor-default"
            >
              {/* Quote icon */}
              <div className="mb-5">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-double-quotes-l text-2xl text-primary-yellow"></i>
                </div>
              </div>

              {/* Text */}
              <p className="text-gray-700 text-base leading-relaxed mb-8 flex-1">
                &ldquo;{t.text}&rdquo;
              </p>

              {/* Footer */}
              <div className="flex items-center gap-4 pt-6 border-t border-gray-100">
                <div className={`w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-full text-sm font-bold ${t.color}`}>
                  {t.initials}
                </div>
                <div>
                  <p className="text-sm font-bold text-black">Cliente</p>
                  <p className="text-xs text-gray-400">{t.context}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Trust line */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5, duration: 0.6 }}
          className="mt-14 flex items-center justify-center gap-3 text-sm text-gray-400"
        >
          <i className="ri-shield-check-line text-primary-yellow text-base"></i>
          <span>Testimonios de personas reales que completaron su posesión efectiva con nosotros</span>
        </motion.div>
      </div>
    </section>
  );
};

export default PosesionTestimonials;
